export default __webpack_public_path__ + "static/media/perfume2.b6ab8f42.jpg";